import { useRichiestaServer } from '@lucan/base-ui'
import { useSessione } from 'context/SessioneProvider'

export function useRichiestaServerLogged() {
  const { inviaOperazione, inAttesaDelServer, ScatolaMessaggi } = useRichiestaServer({calcolaErroreCustom})
  const {setSessioneScaduta} = useSessione()
  
  // wrapper che forza sempre withCredentials: true
  const inviaOperazioneWrapped = async (opId, userInfoDaMandare, data, opzioniRichiestaHttp={}) => {
    return inviaOperazione(
      opId, 
      userInfoDaMandare, 
      data, {
      ...opzioniRichiestaHttp,
      withCredentials: true,
    })
  }

  function calcolaErroreCustom(error) {
    let messaggioPresente_CorrispondenteAlCodice
    let deveRitornareNull

    const messaggiServerConcatenati = error.messaggi
      .filter(({ livello }) => livello !== 'DEBUG')
      .map(({ msg, codice }) => {
        if (codice === 'SESSIONE_SCADUTA') {
          setSessioneScaduta();
        }
 
        return msg
      })
      .join(', ')

    if (deveRitornareNull) return null
    return messaggioPresente_CorrispondenteAlCodice
      || { key: `Si è verificato un errore: ${messaggiServerConcatenati}` }
  }


  return {
    inviaOperazione: inviaOperazioneWrapped,
    inAttesaDelServer,
    ScatolaMessaggi
  }
}


